import { render, staticRenderFns } from "./modalAlert.vue?vue&type=template&id=afe376ee&"
import script from "./modalAlert.vue?vue&type=script&lang=js&"
export * from "./modalAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports